import React from 'react';
import PublicPageLayout from '../PublicPageLayout';
import About from '../../../../../pages/post-auth/home/about/about.component';

const AboutPage = ({ history }) => (
  <PublicPageLayout history={history}>
    <About />
  </PublicPageLayout>
);

export default AboutPage;

